import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { BarChart3, Building2, CreditCard, FileCode2, LayoutTemplate, LogOut, Megaphone, ShieldCheck, UsersRound } from 'lucide-react';
import { getUser, removeToken } from '../api/auth';

const items = [
  ['Overview', '/admin', BarChart3],
  ['Organizations', '/admin/organizations', Building2],
  ['Templates', '/admin/templates', LayoutTemplate],
  ['Creatives', '/admin/creatives', FileCode2],
  ['Campaigns', '/admin/campaigns', Megaphone],
  ['Subscriptions', '/admin/subscriptions', CreditCard],
  ['Plans', '/admin/plans', ShieldCheck],
  ['Organization users', '/admin/users', UsersRound],
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const user = getUser();

  const logout = () => {
    removeToken();
    localStorage.clear();
    localStorage.removeItem('ctv_user');
    navigate('/');
  };

  return <div className="min-h-screen bg-slate-50 text-slate-800 md:flex">
    <aside className="w-full bg-slate-950 px-4 py-5 text-slate-300 md:fixed md:inset-y-0 md:w-64">
      <div className="mb-8 flex items-center gap-3 px-3 text-white">
        <span className="grid h-9 w-9 place-items-center rounded-xl bg-indigo-500 font-bold">S</span>
        <div>
          <p className="font-semibold">SocialTV</p>
          <p className="text-xs text-slate-400">Super Admin</p>
        </div>
      </div>

      <nav className="grid grid-cols-2 gap-1 md:block">
        {
          items.map(([label, to, Icon]) => <NavLink end={to === '/admin'} key={to} to={to} className={({ isActive }) => `mb-1 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition ${isActive ? 'bg-indigo-500 text-white shadow-lg shadow-indigo-950/30' : 'hover:bg-slate-800 hover:text-white'}`}>
            <Icon size={17} />{label}</NavLink>
          )}
      </nav>

      <button onClick={logout} className="mt-6 flex w-fit items-center gap-3 rounded-lg px-3 py-2.5 text-sm hover:bg-slate-800 hover:text-white md:absolute md:bottom-6">
        <LogOut size={17} />Sign out
      </button>
    </aside>

    <main className="min-w-0 flex-1 md:ml-64">
      <header className="flex items-center justify-between border-b border-slate-200 bg-white px-5 py-4 sm:px-8">
        <div>
          <p className="text-sm text-slate-500">Platform administration</p>
          <h1 className="text-lg font-semibold">Welcome, {user?.name || 'Admin'}</h1>
        </div>
        <span className="rounded-full bg-indigo-50 px-3 py-1 text-xs font-semibold text-indigo-700">Super Admin</span>
      </header>
      <div className="p-5 sm:p-8">
        <Outlet />
      </div>
    </main>
  </div>;
}
